import {
  AnalyzeCsvRequest,
  AnalyzeCsvResponse,
  BuyerImport,
  ImportBuyerContext,
  ImportRequest,
  ImportResponse,
  PatchBuyer,
  ReadBuyer,
} from '@tinct/core-api-models';
import {ApiClient} from '../api-client/api-client';
import {ApiCollectionResponse, GetCollectionQueryParams, GetQueryByIdParams,} from '../types';

export interface GetBuyersFilter {
  organizationId?: string;
}

export class BuyersEndpoint {
  constructor(private client: ApiClient) {}

  async getBuyer(params: GetQueryByIdParams<ReadBuyer>): Promise<ReadBuyer> {
    return this.client.getById<ReadBuyer>(
      `/api/v1/buyers/${params.id}`,
      params.fields,
    );
  }

  async getBuyers(
    params: GetCollectionQueryParams<ReadBuyer, GetBuyersFilter>,
  ): Promise<ApiCollectionResponse<ReadBuyer>> {
    const { fields, offset, limit, filters, staticParams, sort } = params;
    return this.client.getCollection<ReadBuyer>('/api/v1/buyers', fields, {
      offset,
      limit,
      ...filters,
      ...staticParams,
      sort,
    });
  }

  async patchBuyer(id: string, data: PatchBuyer): Promise<ReadBuyer> {
    return this.client.patch<ReadBuyer>(`/api/v1/buyers/${id}`, data);
  }

  async deleteBuyer(id: string): Promise<void> {
    return this.client.delete(`/api/v1/buyers/${id}`);
  }

  async analyzeCsv(
    data: AnalyzeCsvRequest<ImportBuyerContext>
  ): Promise<AnalyzeCsvResponse> {
    return this.client.post<AnalyzeCsvResponse>('/api/v1/buyers/_analyze-csv', data);
  }

  async importBuyers(
    data: ImportRequest<BuyerImport, ImportBuyerContext>
  ): Promise<ImportResponse> {
    return this.client.post<ImportResponse>('/api/v1/buyers/_import', data);
  }
}
